import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ApprovePostListLayer from "../../components/Post/ApprovePostListLayer";


const ApprovePostList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Approved Post" />

        {/* UsersListLayer */}
        <ApprovePostListLayer />

      </MasterLayout>

    </>
  );
};

export default ApprovePostList;
